import React, { useCallback, useEffect, useState } from "react";
import { FloatLabel } from "primereact/floatlabel";
import { toast } from "react-hot-toast";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { productService } from "../../services/product";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dropdown } from "primereact/dropdown";
import { useQuery } from "@tanstack/react-query";
export default function CheckList({
  isOpen,
  onClose,
  onSubmit,
  initialData, 
  mutation, 
}) {
  const [formData, setFormData] = useState({
    id: 0,
    currentId: 0,
    date: new Date().toISOString(),
    voucherNo: "",
    currentTitle: "",
    voucherRows: [],
  });
  const { data,productsLoading } = useQuery({
    queryKey: ["currentProducts"],
    queryFn: productService.getCurrentProducts,
  });

  const products = Array.isArray(data) ? data : [];
 
  useEffect(() => {
     
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData(
        {
        id: 0,
        currentId: 0,
        date: new Date().toISOString(),
        voucherNo: "",
        currentTitle: "",
        voucherRows: [],
      }
    );
    }
    
  }, [initialData]);
  const handleAddProduct = useCallback((product) => {
    console.log(product)
    const newProduct = {
      stockId: product.id,
      parcel: "",
      kilos: null,
      meters: null,
      rollCount: null,
      stockName: product.urunAdi,
      stockCode: product.kodu,
      processInstruction: "",//işlem talimatı
      requestedWidth:"",//istenen en
      rollStyle:"",//sarım şekli
      description :"",//açıklama

      details: [],
    };
  
    setFormData((prevData) => {
      // Eğer voucherRows undefined veya null ise, boş bir dizi olarak başlatın
      const newVoucherRows = prevData?.voucherRows ? [...prevData.voucherRows, newProduct] : [newProduct];
      return {
        ...prevData,
        voucherRows: newVoucherRows,
      };
    });
  }, []);
  
  const handleRemoveProduct = useCallback((index) => {
    setFormData((prevData) => {
      // Eğer voucherRows undefined veya null ise, boş bir dizi olarak başlatın
      const newVoucherRows = prevData?.voucherRows ? prevData.voucherRows.filter((_, i) => i !== index) : [];
      return {
        ...prevData,
        voucherRows: newVoucherRows,
      };
    });
  }, []);
  
  const handlePrint = async () => {
    const invalidProducts = formData.voucherRows.map((product) => {
      return {
        ...product,
        isError: {
          parcel: !product.parcel,
          kilos: !product.kilos,
          meters: !product.meters,
          rollCount: !product.rollCount,
          processInstruction: !product.processInstruction,
    
          rollStyle: !product.rollStyle, 
        },
      };
    });
  
    const hasError = invalidProducts.some(
      (product) =>
        !product.parcel ||
        !product.kilos ||
        !product.meters ||
        !product.rollCount||
        !product.processInstruction||
    
        !product.rollStyle 
    );
  
    if (hasError) {
      toast.error("Tüm Kırmızı Alanları Doldurunuz...");
      return;
    }
  
    const parcelDuplicates = formData.voucherRows.some(
      (product, index, self) =>
        self.findIndex((p) => p.parcel === product.parcel) !== index
    );
  
    if (parcelDuplicates) {
      toast.error("Aynı parti numarasını birden fazla kez ekleyemezsiniz");
      return;
    }
  
 
    onSubmit(formData);
  };
  

  const footer = () => (
    <div className="   flex justify-content-between w-full align-items-center">
      {/* Toplam Ürün Sayısı */}
      <span className="pl-3 text-center">
        Toplam {formData?.voucherRows?.length} ürün seçildi
      </span>
      {/* Oluştur Butonu */}
      <Button loading={mutation.isPending}
        disabled={formData?.voucherRows?.length > 0 ? false : true}
        label={initialData ?"Listeyi Güncelle":"Liste Oluştur"}
        icon="pi pi-check"
        className="p-button-success    border-noround-top border-noround-left"
        onClick={handlePrint}
      />
    </div>
  );
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex gap-1">
        <React.Fragment>
          <Button
            label="Ekle"
            icon="pi pi-plus"
            size="small"
            text
            className="p-0 m-0"
            onClick={() => handleAddProduct(rowData)}
          />
        </React.Fragment>
      </div>
    );
  };
  const template2 = {
    layout: "CurrentPageReport PrevPageLink NextPageLink",

    CurrentPageReport: (options) => {
      return (
        <span
          style={{
            color: "var(--text-color)",
            userSelect: "none",
            textAlign: "center",
          }}
        >
          {options.first} - {options.last} / {options.totalRecords}
        </span>
      );
    },
  };
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    "country.name": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    representative: { value: null, matchMode: FilterMatchMode.IN },
    status: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
  });
  const onGlobalFilterChange = (event) => {
    const value = event.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
  };
  const renderHeader = () => {
    const value = filters["global"] ? filters["global"].value : "";

    return (
      <div className="flex  align-items-center justify-content-between ">
        <span className="w-full">{"Ürün Seç"}</span>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            type="search"
            value={value || ""}
            className="w-full"
            onChange={(e) => onGlobalFilterChange(e)}
            placeholder="Ürün Ara"
          />
        </IconField>
      </div>
    );
  };

  const header = renderHeader();

  return (
    <Dialog
      className="max-w-full w-11 md:w-11 xl:w-9"
      visible={isOpen}
      footer={footer()}
      onHide={onClose}
      header={initialData ? "Liste Güncelle" : "Yeni Liste Oluştur"}
    >
      <div className="pt-4 ">
        <div className="flex grid">
          {/* Ürün Seç Bölümü */}
          <div className="col-12 md:col-6">
            <Card title={header} className="shadow-3 border-round-md">
              <DataTable
                className="border-round-md shadow-1   border-1 surface-border border-round"
                scrollable
                scrollHeight="40vh"
                paginator
                filters={filters}
                onFilter={(e) => setFilters(e.filters)}
                rows={10}
                paginatorTemplate={template2}
                rowsPerPageOptions={[10, 25, 50]}
                value={products}
                loading={productsLoading}
                tableStyle={{ minWidth: "25rem" }}
                emptyMessage="Liste Boş"
              >
                <Column
                  header="İşlemler"
                  className="hide-on-large"
                  headerClassName="hide-on-large"
                  alignHeader="center"
                  align="center"
                  headerStyle={{ width: "20%" }}
                  bodyStyle={{ textAlign: "center" }}
                  body={actionBodyTemplate}
                />
                <Column
                  field="urunAdi"
                  header="Ürün Adı"
                  style={{ width: "70%" }}
                />
                <Column
                  header="İşlemler"
                  alignHeader="center"
                  align="center"
                  className="hide-on-small"
                  headerClassName="hide-on-small"
                  headerStyle={{ width: "20%" }}
                  bodyStyle={{ textAlign: "center" }}
                  body={actionBodyTemplate}
                />
              </DataTable>
            </Card>
          </div>

          {/* Seçilen Ürünler Bölümü */}
          <div className="col-12 md:col-6">
            <Card title="Eklenen Partiler" className="shadow-3 border-round-md">
              <div style={{ maxHeight: "50.7vh", overflowY: "auto" }}>
                {formData?.voucherRows?.map((product, index) => (
                  <div
                    key={index}
                    className="flex  mt-3 align-items-center justify-content-between 
              border-1 surface-border border-round shadow-2 mb-1"
                  >
                    <div className="col-12">
                      {/* Ürün Başlığı */}
                      <div className="flex mb-3 justify-content-between">
                        <div className="font-medium pl-2   align-content-center text-primary">
                          {product.stockName}
                        </div>
                        {/* Kaldır Butonu */}
                        <Button
                          icon="pi pi-trash"
                          size="small"
                          text
                          className="p-button-danger p-button-sm"
                          onClick={() => handleRemoveProduct(index)}
                        />
                      </div>

                      {/* Input Alanları */}
                      <div className="grid">
                     
                      
                        <div className="col-6 md:col-3 mt-2">
                          <FloatLabel>
                            <InputNumber  useGrouping={false}
                              className={`w-full ${
                                !product.parcel ? "p-invalid" : ""
                              }`}
                              value={product.parcel || null}
                              onValueChange={(e) => {
                                const newParcel = e.value || null;
                              
                                setFormData((prev) => ({
                                  ...prev,  
                                  voucherRows: prev.voucherRows.map((p, i) =>
                                    i === index
                                      ? { ...p, parcel: newParcel }  
                                      : p
                                  ),
                                }));
                              }}
                              
                            />
                            <label htmlFor="parcel">Parti No</label>
                          </FloatLabel>
                        </div>
                        <div className="col-6 md:col-3 mt-2">
                          <FloatLabel>
                            <InputNumber
                              className={`w-full ${
                                !product.kilos ? "p-invalid" : ""
                              }`}
                              value={product.kilos || null}
                              onValueChange={(e) => {
                                const newKilos = e.value || null;
                              
                                setFormData((prev) => ({
                                  ...prev, // önceki verileri koruyoruz
                                  voucherRows: prev.voucherRows.map((p, i) =>
                                    i === index
                                      ? { ...p, kilos: newKilos } // sadece belirtilen satırı güncelliyoruz
                                      : p
                                  ),
                                }));
                              }}
                              
                            />
                            <label htmlFor="kilos">Kilo</label>
                          </FloatLabel>
                        </div>

                        <div className="col-6 md:col-3 mt-2">
                          <FloatLabel>
                            <InputNumber
                              className={`w-full ${
                                !product.meters ? "p-invalid" : ""
                              }`}
                              value={product.meters ||null}
                              onValueChange={(e) => {
                                const newMeters = e.value || null;
                              
                                setFormData((prev) => ({
                                  ...prev, // önceki verileri koruyoruz
                                  voucherRows: prev.voucherRows.map((p, i) =>
                                    i === index
                                      ? { ...p, meters: newMeters } // sadece belirtilen satırı güncelliyoruz
                                      : p
                                  ),
                                }));
                              }}
                              
                             
                            />
                            <label htmlFor="meters">Metre</label>
                          </FloatLabel>
                        </div>

                        <div className="col-6 md:col-3 mt-2">
                          <FloatLabel>
                            <InputNumber
                              className={`w-full ${
                                !product.rollCount ? "p-invalid" : ""
                              }`}
                              value={product.rollCount ||null}
                              onValueChange={(e) => {
                                const newRollCount = e.value || null;
                              
                                setFormData((prev) => ({
                                  ...prev, // önceki verileri koruyoruz
                                  voucherRows: prev.voucherRows.map((p, i) =>
                                    i === index
                                      ? { ...p, rollCount: newRollCount } // sadece belirtilen satırı güncelliyoruz
                                      : p
                                  ),
                                }));
                              }}
                               
                            />
                            <label htmlFor="rollCount">Top</label>
                          </FloatLabel>
                        </div>      
                        <div className="col-12 md:col-6 mt-2">
                          <FloatLabel>
                            <InputText
                              className={`w-full ${
                                !product.processInstruction || product.processInstruction.length === 0
                                  ? "p-invalid"
                                  : ""
                              }`}
                              value={product.processInstruction||""}
                              onChange={(e) => {
                                const value = e.target.value;
                               
                                
                              
                                setFormData((prevData) => ({
                                  ...prevData,  
                                  voucherRows: prevData.voucherRows.map((p, i) =>
                                    i === index
                                      ? { ...p, processInstruction: value }  
                                      : p
                                  ),
                                }));
                              }}
                              
                            />
                            <label htmlFor="parcel">İşlem Talimatı</label>
                          </FloatLabel>
                        </div>  
                         <div className="col-12 md:col-6 mt-2">
                          <FloatLabel>
                            <InputText
                              className={`w-full  `}
                              value={product.requestedWidth||""}
                              onChange={(e) => {
                                const value = e.target.value;
                               
                               
                              
                                setFormData((prevData) => ({
                                  ...prevData,  
                                  voucherRows: prevData.voucherRows.map((p, i) =>
                                    i === index
                                      ? { ...p, requestedWidth: value }  
                                      : p
                                  ),
                                }));
                              }}
                              
                            />
                            <label htmlFor="parcel">İstenen En</label>
                          </FloatLabel>
                        </div>
                        <div className="col-12 md:col-6 mt-2">
      <FloatLabel>
        <Dropdown
          value={product.rollStyle || ""}
          options={[
            { label: 'Tek Kat Rulo', value: 'Tek Kat Rulo' },
            { label: 'Çift Kat Rulo', value: 'Çift Kat Rulo' },
            { label: '4 Kat Tambur', value: '4 Kat Tambur' },
            { label: 'Çift Kat Tambur', value: 'Çift Kat Tambur' }
          ]}
          onChange={(e) => {
            const value = e.value;
        
            setFormData((prevData) => ({
              ...prevData,
              voucherRows: prevData.voucherRows.map((p, i) =>
                i === index
                  ? { ...p, rollStyle: value }
                  : p
              ),
            }));
          }}
          placeholder="Sarım Şekli Seçin"
          className={`w-full ${!product.rollStyle || product.rollStyle.length === 0 ? "p-invalid" : ""}`}
          optionLabel="label"
          optionValue="value"
        />
        <label htmlFor="parcel">Sarım Şekli</label>
      </FloatLabel>
    </div>
                         <div className="col-12 md:col-6 mt-2">
                          <FloatLabel>
                            <InputText
                              className={`w-full  `}
                              value={product.description||""}
                              onChange={(e) => {
                                const value = e.target.value;
                               
                               
                              
                                setFormData((prevData) => ({
                                  ...prevData,  
                                  voucherRows: prevData.voucherRows.map((p, i) =>
                                    i === index
                                      ? { ...p, description: value }  
                                      : p
                                  ),
                                }));
                              }}
                              
                            />
                            <label htmlFor="parcel">Açıklama</label>
                          </FloatLabel>
                        </div>
                        

                    
 
                      </div>
                    </div>
                  </div>
                ))}
                {formData?.voucherRows?.length === 0 && (
                  <span className="text-center">
                    Henüz hiçbir ürün seçmediniz.
                  </span>
                )}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
